import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdPerson,
  MdHome,
  MdLock,
  MdCalendarMonth,
  MdDescription,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';
import Calendar from 'views/admin/calendar';
import Opportunities from 'views/admin/opportunities';
import Payments from 'views/admin/payments';
import Documents from 'views/admin/documents';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUpCentered from 'views/auth/signUp';
import CompleteMagicLink from 'views/auth/completeMagicLink';
import { MdOutlineAddCircleOutline, MdAttachMoney } from 'react-icons/md';

const routes = [
  {
    name: 'Main Dashboard',
    navbarSubtitle: 'Manage your assigned classes, class completion forms, payout setup, and nearby opportunities.',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: MainDashboard,
    hidden: false,
    enabled: true,
  },
  {
    name: 'Calendar',
    navbarSubtitle: 'See your upcoming classes, past classes, and completion forms in one place.',
    layout: '/admin',
    path: '/calendar',
    icon: <Icon as={MdCalendarMonth} width="20px" height="20px" color="inherit" />,
    component: Calendar,
    hidden: false,
    enabled: true,
  },
  {
    name: 'Opportunities',
    navbarSubtitle: 'Browse nearby open classes in your travel area. Stripe setup is only required when you claim a class.',
    layout: '/admin',
    path: '/opportunities',
    icon: <Icon as={MdOutlineAddCircleOutline} width="20px" height="20px" color="inherit" />,
    component: Opportunities,
    hidden: false,
    enabled: true,
  },
  {
    name: 'Class Opportunity',
    navbarSubtitle: 'Review this open class and claim it when it works for your schedule.',
    layout: '/admin',
    path: '/class-opportunities/:classId',
    icon: <Icon as={MdOutlineAddCircleOutline} width="20px" height="20px" color="inherit" />,
    component: Opportunities,
    hidden: true,
    enabled: true,
  },
  {
    name: 'Payouts',
    navbarSubtitle: 'Review payout cards with class, facility, completion, and payout status details.',
    layout: '/admin',
    path: '/payouts',
    icon: <Icon as={MdAttachMoney} width="20px" height="20px" color="inherit" />,
    component: Payments,
    hidden: false,
    enabled: true,
  },
  {
    name: 'Documents',
    navbarSubtitle: 'Upload and review Insurance, Certifications, and Other instructor documents.',
    layout: '/admin',
    path: '/documents',
    icon: <Icon as={MdDescription} width="20px" height="20px" color="inherit" />,
    component: Documents,
    hidden: false,
    enabled: true,
  },
  {
    name: 'Profile',
    navbarSubtitle: 'Keep your class preferences, contact info, and teaching profile current.',
    layout: '/admin',
    path: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Profile,
    hidden: false,
    enabled: true,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
    hidden: true,
    enabled: true,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignUpCentered,
    hidden: true,
    enabled: true,
  },
  {
    name: 'Complete Sign In',
    layout: '/auth',
    path: '/complete-signin',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: CompleteMagicLink,
    hidden: true,
    enabled: true,
  },
];

export default routes;
